// extracted by mini-css-extract-plugin
export default {"studentAnswerTemplate":"AnswersTemplate_studentAnswerTemplate__s3bsb","hideReport":"AnswersTemplate_hideReport__XDAxO"};